import { SET_LAST_ORDER } from "../actions/order";

const initialState = {
  lastOrder: null,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_LAST_ORDER:
      return {
        ...state,
        lastOrder: action.payload,
      };
    default:
      return state;
  }
}
